// extracted by mini-css-extract-plugin
export var addToCartButton = "_ok-b";
export var arrowButtonContainer = "_ok-9";
export var arrowButtonIcon = "_ok-a";
export var carouselArrowButton = "_ok-6";
export var carouselElementContainer = "_ok-1";
export var left = "_ok-7";
export var productDisplayCarouselContainer = "_ok-0";
export var productTileContainer = "_ok-2";
export var productTileImage = "_ok-4";
export var productTileImageContainer = "_ok-3";
export var productTileTitle = "_ok-5";
export var right = "_ok-8";
export var sliderOverflow = "_ok-c";